import {platformAPI} from "../../../api/axiosConfig";

export type AudioSlot = {
    ttsText?: string;
    audioPath?: string;
    status: string; // pending, processing, ready, error
    updatedAt: string;
};

export type SirenPhoneCallConfig = {
    id: string;
    clientID?: string;
    departmentID?: string;
    preMessage?: AudioSlot;
    postDtmf?: AudioSlot;
    invalidOption?: AudioSlot;
    inboundCall?: AudioSlot;
    forwardingCall?: AudioSlot;
    alertNotFound?: AudioSlot;
    alreadyResponded?: AudioSlot;
    callForwardingEnabled: boolean;
    callForwardingNumber?: string;
    updatedBy: string;
    updatedAt: string;
};

export async function getSirenPhoneCallConfigExact(params: {clientID?: string; departmentID?: string}): Promise<SirenPhoneCallConfig | null> {
    try {
        const res = await platformAPI.get<SirenPhoneCallConfig>("api/siren/phone-call-config/exact", {params});
        return res.data;
    } catch {
        return null;
    }
}
